

export default {
  SET_ITEMS(state, payload) {
    state.historiques = payload
  }
}
